module.exports = __webpack_public_path__ + "img/signature-header.9de4aeea.png";